import type { FunctionComponent } from "react"

import { clsx } from "clsx"
import Image from "next/image"

import empoweredByJobteaserBlack from "@/modules/brand/assets/empowered_by_jobteaser-black.svg"
import empoweredByJobteaserWhite from "@/modules/brand/assets/empowered_by_jobteaser-white.svg"

import styles from "./Brand.module.css"

type CCLogoProps = {
  from: "footer" | "header"
  logo: string
  name: string
  secondaryLogo?: string
}

export const CCLogo: FunctionComponent<CCLogoProps> = ({ from, logo, name, secondaryLogo }) => {
  const logoClassname = clsx(styles["app-Brand__CcLogo"], {
    [styles["app-Brand__CcLogo___footer"]]: from === "footer",
  })

  return (
    <div className={logoClassname}>
      <img alt={name} className={styles["app-Brand__CcImage"]} src={logo} />
      {secondaryLogo && <img alt={name} className={styles["app-Brand__CcImage"]} src={secondaryLogo} />}
      <div className={styles["app-Brand__CcTitleGroup"]}>
        <div className={styles["app-Brand__CcTitle"]}>{name}</div>
        <Image
          alt="Empowered by JobTeaser"
          className={styles["app-Brand__CcSubtitle"]}
          height={9}
          priority={from === "header"}
          src={from === "header" ? empoweredByJobteaserBlack : empoweredByJobteaserWhite}
          width={110}
        />
      </div>
    </div>
  )
}
